import { t } from '@lingui/core/macro';
import { Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function ListItemError(props) {
    const { label, onRefresh } = props;
    return (<Menu.Item onClick={onRefresh}>
      <Falcon icon="exclamation-triangle"/>
      <Menu.ItemText primary={label} secondary={t({
            message: 'Failed, click to refresh',
            comment: 'Add Metadata Pair: Distinct value selection - Error message',
        })}/>
    </Menu.Item>);
}
